import React from "react";
import thousandsFormat from "@/modules/thousandsFormat";

interface IProps {
    langStr: string,
    winamount: number
}

export default class YouWonModal extends React.Component<IProps> {
    private winAnimation: JSX.Element;

    readonly winGifAddress = "/assets/img/you_won.gif";

    state = {
        showWinAmount: false
    };

    constructor(props: IProps) {
        super(props);
        this.startAnimation();
    }

	private startAnimation() {
		this.winAnimation = <img key="BM_win_sWT" src={this.winGifAddress + "?a=" + Math.random()} alt={`YOU WON!`} />;
		window.setTimeout(() => { this.setState({ showWinAmount: true }); }, 1200);
		window.setTimeout(() => { this.setState({ showWinAmount: false }); }, 3900);
		window.setTimeout(() => { delete this.winAnimation; }, 4500);
    }

    render() {
		const
			{showWinAmount} = this.state,
        	{winamount, langStr} = this.props;
        
        return (
            <div className="modal-container win">
                { this.winAnimation }

                {
                    showWinAmount ? (
                        <div key="BW_sWA" className="modal-win-amount">
                            {thousandsFormat(winamount, langStr)}
                        </div>
                    ) : null
                }
            </div>
        );
    }
}